var React = require('react');

function MapMarkerMinus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4a24 24 0 0 0 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm112 200a16 16 0 0 1-16 16H96a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M304 184v16a16 16 0 0 1-16 16H96a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

MapMarkerMinus.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = MapMarkerMinus;

MapMarkerMinus.default = MapMarkerMinus;
